import { IFetchDataState, IPagination } from '@interfaces/common';
import { InquiryDetails } from '@models/inquiries';

export interface IInquiriesStateChunk extends IFetchDataState {
  data: InquiryDetails[];
  pagination: Partial<IPagination>;
}

export enum TInquiriesListKey {
  InProgress = 'inProgress',
  Complete = 'complete',
}

export type IInquiriesState = Record<TInquiriesListKey, IInquiriesStateChunk>;
